import React from "react";
import { Grid, Col, Row } from "react-styled-flexboxgrid";
import Truncate from "react-truncate-html";
import { Link } from "react-router-dom";

import ImgWeAre from "assets/images/bigpicture/img-we-are.png";
import {
  SectionPointer,
  SectionTitle,
  Link as StyledLink,
} from "components/elements";

import { TopicMenuProvider } from "components";

import theme from "styles/theme";

import ExploreTopicsContainer from "./index.style";
import { TotalVotes } from "components/stats";

// TODO Refactor landing page and big picture page explore topic cards as one common component
const ExploreTopicsDisplay = ({ content }) => {
  return (
    <Row className="topics">
      {content.topicsAndSubtopicsMenu.topics.map((topic, index) => (
        <Col
          xs={12}
          sm={6}
          md={4}
          lg={3}
          key={index}
          as={Link}
          to={`/topic/${topic.slug}`}
        >
          <div
            className="topic"
            style={{
              backgroundImage: `url(${
                topic.better_featured_image
                  ? topic.better_featured_image.source_url
                  : ""
              })`,
            }}
          >
            <div
              className="summary"
              style={{
                borderBottom: `6px solid ${topic.acf.topic_border_color}`,
              }}
            >
              <h3>{topic.title.rendered}</h3>
              <p className="xs">
                <Truncate
                  lines={1}
                  dangerouslySetInnerHTML={{
                    __html: topic.acf.topic_summary,
                  }}
                />
              </p>
              <TotalVotes topic={topic.title.rendered} />
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
};

const ExploreTopics = () => {
  return (
    <ExploreTopicsContainer>
      <div className="wrapper">
        <div className="container">
          <Grid>
            <Row>
              <Col md={9} mdOffset={2} className="section-title">
                <div className="title">
                  <SectionPointer
                    firstColor="#EF233C"
                    secondColor="rgba(50,46,108,0.8)"
                  />
                  <SectionTitle color={theme.primary.spaceCadet}>
                    Explore the data
                  </SectionTitle>
                </div>
                <p className="description">
                  Understanding Houston is divided into eight key topics and 43
                  subtopics affecting quality of life in Houston’s three largest
                  counties. Within these eight topics, you’ll encounter over 200
                  indicators that provide valuable context to the issues that
                  matter most in our communities.
                </p>
                <br />
                <p>
                  <strong>We want your input!</strong> As you explore the data,
                  you’re invited to vote on up to 10 issues you think need more
                  attention, resources, and collaborative action. Community
                  votes will inform the issues the Greater Houston Community
                  Foundation explores more deeply as part of Understanding
                  Houston’s commitment to help us all learn, engage, and act.{" "}
                </p>
                <br />
              </Col>
            </Row>

            <TopicMenuProvider loading={() => null} error={() => null}>
              <ExploreTopicsDisplay />
            </TopicMenuProvider>
            <Row>
              <Col md={10} mdOffset={1}>
                <h3>Key issues your community is voting for:</h3>
                <div
                  className="data-viz"
                  data-chart="Total Votes by Topics & Subtopics"
                />
              </Col>
            </Row>
          </Grid>
        </div>
        <div className="cta">
          <div className="cta-wrapper">
            <div className="container">
              <Grid>
                <Row>
                  <Col small={12} md={6} className="column">
                    <img src={ImgWeAre} alt="we-are" />
                  </Col>
                  <Col small={12} md={6} className="column">
                    <div className="content">
                      <h3>
                        We are <b>always listening!</b>
                      </h3>
                      <p>
                        Understanding Houston will evolve over time based on
                        user feedback and your input. Let us know what matters
                        to you!
                      </p>
                      <StyledLink as={Link} to="/contact">
                        Contact us
                      </StyledLink>
                    </div>
                  </Col>
                </Row>
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </ExploreTopicsContainer>
  );
};

export default ExploreTopics;
